function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashedCircleCart = function SvgDashedCircleCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 48,
    height: 48,
    rx: 24,
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "5 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.083 16.5833H18.4163L20.6497 27.7416C20.7259 28.1253 20.9346 28.4699 21.2393 28.7152C21.544 28.9605 21.9253 29.0908 22.3163 29.0833H30.4163C30.8074 29.0908 31.1887 28.9605 31.4934 28.7152C31.7981 28.4699 32.0068 28.1253 32.083 27.7416L33.4163 20.75H19.2497M22.583 33.25C22.583 33.7102 22.2099 34.0833 21.7497 34.0833C21.2894 34.0833 20.9163 33.7102 20.9163 33.25C20.9163 32.7897 21.2894 32.4166 21.7497 32.4166C22.2099 32.4166 22.583 32.7897 22.583 33.25ZM31.7497 33.25C31.7497 33.7102 31.3766 34.0833 30.9163 34.0833C30.4561 34.0833 30.083 33.7102 30.083 33.25C30.083 32.7897 30.4561 32.4166 30.9163 32.4166C31.3766 32.4166 31.7497 32.7897 31.7497 33.25Z",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgDashedCircleCart;